import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';
import { UiDrawer } from 'ui-components';
import { marginLeft, marginRight, paddingLeft } from 'utils';

export const StyledDrawer = styled(UiDrawer)(
  ({ theme }) => css`
    .MuiPaper-root {
      height: calc(100% - 32px);
      border-radius: 0;
    }

    .wrapper {
      padding: 0;
      border-left: none;

      .header {
        .MuiButton-root {
          ${marginRight('auto')}
        }

        .back-button {
          color: ${theme.palette.gray.dark};
          ${paddingLeft('0 !important')}

          .MuiButton-endIcon {
            ${marginLeft('0')}

            .icon {
              color: ${theme.palette.gray.dark};
            }
          }
        }
      }

      .body {
        height: 75vh;
        max-height: 75vh;

        h1 {
          color: ${theme.palette.naturals.black};
          font-size: ${theme.typography.subtitle.fontSize};
          font-weight: ${theme.typography.subtitle.fontWeight};
          line-height: ${theme.typography.subtitle.lineHeight};
        }

        .filter-resources {
          label {
            display: flex !important;
          }
        }

        &.details {
          margin-left: 16px;
        }
      }

      .filter-item {
        &.selected {
          border: 1px solid transparent;
        }
      }

      .filter {
        ${marginLeft('8px')}
      }
    }
  `
);

export const StyledBottomSheets = styled('div')(
  ({ theme }) => css`
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${theme.palette.naturals.white};
    z-index: 9999;
    padding: 12px 16px;
    gap: 16px;
    display: flex;
    box-shadow: 0px 0px 100px 0px rgba(0, 0, 0, 0.15);
  `
);
